export const PERMISSION_KEYS = [
  'dashboard',
  'quotations',
  'invoices',
  'payments',
  'employees',
  'reports',
  'inventory',
  'projectCosts',
  'dalale',
  'apartmentRegistry',
  'settings',
  'users'
];

export const PERMISSION_LABELS = {
  dashboard: 'Dashboard',
  quotations: 'Quotation',
  invoices: 'Invoice',
  payments: 'Lacagaha',
  employees: 'Shaqaalaha',
  reports: 'Warbixinaha',
  inventory: 'Inventory',
  projectCosts: 'Qarash Mashruuc',
  dalale: 'Dalale',
  apartmentRegistry: 'Diiwaanka Guryaha',
  settings: 'Settings',
  users: 'User management'
};

export const ROUTE_PERMISSION = {
  '/admin/dashboard': 'dashboard',
  '/admin/quotations': 'quotations',
  '/admin/invoices': 'invoices',
  '/admin/payments': 'payments',
  '/admin/employees': 'employees',
  '/admin/reports': 'reports',
  '/admin/inventory': 'inventory',
  '/admin/project-costs': 'projectCosts',
  '/admin/dalale': 'dalale',
  '/admin/apartment-registry': 'apartmentRegistry',
  '/admin/settings': 'settings',
  '/admin/users': 'users'
};

export const fullPermissions = () =>
  Object.fromEntries(PERMISSION_KEYS.map((k) => [k, true]));

export const clerkPermissions = () => ({
  ...Object.fromEntries(PERMISSION_KEYS.map((k) => [k, false])),
  dashboard: true,
  quotations: true,
  invoices: true
});

export const normalizeUserPermissions = (userData) => {
  if (!userData) return {};
  if (userData.role === 'admin') return fullPermissions();
  const base = Object.fromEntries(PERMISSION_KEYS.map((k) => [k, false]));
  return { ...base, ...(userData.permissions || {}) };
};

export const canAccess = (userData, permissionKey) => {
  if (!userData) return false;
  if (userData.role === 'admin') return true;
  if (userData.isActive === false) return false;
  return Boolean(normalizeUserPermissions(userData)[permissionKey]);
};

export const canAccessPath = (userData, pathname) => {
  if (!pathname.startsWith('/admin')) return true;
  const routes = Object.entries(ROUTE_PERMISSION).sort((a, b) => b[0].length - a[0].length);
  for (const [route, key] of routes) {
    if (pathname === route || pathname.startsWith(`${route}/`)) {
      return canAccess(userData, key);
    }
  }
  return true;
};
